import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getRoomTypes, deleteRoomType } from "services/RoomTypeService";

const RoomTypeList = () => {
  const [roomTypes, setRoomType] = useState([]);
  const [filteredRoomType, setFilteredRoomType] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [deleteRoomTypeId, setDeleteRoomTypeId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    getRoomTypeList();
  }, []);

  useEffect(() => {
      handleSearch();
    }, [searchQuery]);
  
    const getRoomTypeList = () => {
      getRoomTypes().then((response) => {
        if (response && response.data.success) {
          setRoomType(response.data.roomTypes);
          setFilteredRoomType(response.data.roomTypes);
        }
      });
    };
  
    const handleSearch = () => {
      const query = searchQuery.toLowerCase();
      const filtered = roomTypes.filter(
        (roomRoomType) =>
          roomRoomType.room_type?.toLowerCase().includes(query) 
      );
      setFilteredRoomType(filtered);
      setPage(0);
    };
  
    const handleChangePage = (newPage) => setPage(newPage);
    const handleRowsPerPageChange = (e) => {
      setRowsPerPage(parseInt(e.target.value, 10));
      setPage(0);
    };
  
    const paginatedRoomType = filteredRoomType.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  
    const handleCreate = () => {
      navigate("/add-room-type", { state: { isEdit: false } });
    };
  
    const handleEdit = (roomType) => {
      navigate("/add-room-type", { state: { isEdit: true, editFormData: roomType } });
    };
   
    const delRoomType = (id) => {
      setDeleteRoomTypeId(id);
      setShowDeleteModal(true);
    };
    
    const confirmDeleteRoomType = () => {
  
      deleteRoomType(deleteRoomTypeId).then((response) => {
        if (response && response.data.success) {
          setShowDeleteModal(false);
          getRoomTypeList();
        }
      });
      
    };

  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-hotel"></i>
        </div>
        <div className="header-title">
          <h1>Manage RoomType</h1>
          <small>RoomType List</small>
        </div>
      </section>

      <section className="content">
        <div className="row">
          <div className="col-lg-12 pinpin">
            <div className="buttonexport" id="buttonlist">
              <Link className="btn btn-add" to="/add-room-type">
                <i className="fa fa-plus"></i> Add  RoomType
              </Link>
            </div>
            <div className="card lobicard mt-2" data-sortable="true">
              <div className="card-header">
                <div className="card-title custom_title">
                  <h4>RoomType List</h4>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    id="dataTableExample1"
                    className="table table-bordered table-striped table-hover"
                  >
                    <thead className="back_table_color">
                      <tr class="info">
                        <th>Sno. </th>
                        <th>Type </th>                       
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                    {filteredRoomType.length > 0 ? (
                        filteredRoomType.map((roomType, index) => (
                        <tr>
                        <td>{index+1}</td>
                        <td>{roomType.room_type}</td>                        
                        <td>
                          <button
                            type="button"
                            className="btn btn-add btn-sm"
                            data-toggle="modal"
                            data-target="#customer1"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(roomType);
                            }}
                          >
                            <i className="fa fa-pencil"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            data-toggle="modal"
                            data-target="#customer2"
                            onClick={(e) => {
                              e.stopPropagation();
                              delRoomType(roomType.id);
                            }}
                          >
                            <i className="fa fa-trash-o"></i>{" "}
                          </button>
                        </td>
                      </tr>
                       ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No agents found.
                          </td>
                        </tr>
                         )}   
                      
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showDeleteModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ zIndex: "9999" }}
          >
            <div className="modal-content">
              <div className="modal-header modal-header-primary">
                <h3>
                  <i className="fa fa-user m-r-5"></i> Delete  RoomType
                </h3>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                  onClick={(e) => {
                    setShowDeleteModal(false);
                  }}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-12 form-group user-form-group">
                          <label className="control-label">Delete  RoomType</label>
                          <div className="float-right">
                            <button
                              type="button"
                              className="btn btn-danger btn-sm mr-3"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowDeleteModal(false);
                              }}
                            >
                              NO
                            </button>
                            <button
                              type="button"
                              className="btn btn-add btn-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                confirmDeleteRoomType();
                              }}
                            >
                              YES
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger float-left"
                  data-dismiss="modal"
                  onClick={(e) => {
                    setShowDeleteModal(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

{/*{showDeleteModal && ( */}
    </>
  );
};

export default RoomTypeList;
